import {combineReducers} from 'redux';
import account from './account'
import slide from './slide'

const reducers = {
    account,
    slide,
};

export default combineReducers(reducers);